import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPublication: null,
};

const currentPublicationSlice = createSlice({
  name: 'currentPublication',
  initialState,
  reducers: {
    setCurrentPublication: (state, action) => {
      state.currentPublication = action.payload;
    },
    updateCurrentPublication: (state, action) => {
      state.currentPublication = { ...state.currentPublication, ...action.payload };
    },
    clearCurrentPublication: (state) => {
      state.currentPublication = {};
    },
  },
});

export const { setCurrentPublication, updateCurrentPublication, clearCurrentPublication } =
  currentPublicationSlice.actions;

export default currentPublicationSlice.reducer;
